(function () {
  function initPremiumDescription(root) {
    if (!root || root.dataset.wfPdescInitialized === 'true') {
      return;
    }

    root.dataset.wfPdescInitialized = 'true';

    var content = root.querySelector(
      '[data-wf-pdesc-content]'
    );

    var button = root.querySelector(
      '[data-wf-pdesc-toggle]'
    );

    var buttonText = root.querySelector(
      '[data-wf-pdesc-toggle-text]'
    );

    if (!content || !button) {
      return;
    }

    /*
     * Check whether the description is actually
     * long enough to require collapsing.
     */
    function checkLength() {
      if (root.classList.contains('is-expanded')) {
        return;
      }

      var collapsedHeight =
        window.innerWidth < 750 ? 185 : 220;

      if (
        content.scrollHeight <=
        collapsedHeight + 20
      ) {
        root.classList.add('is-short');
      } else {
        root.classList.remove('is-short');
      }
    }


    button.addEventListener(
      'click',
      function () {

        var expanded =
          root.classList.toggle(
            'is-expanded'
          );

        button.setAttribute(
          'aria-expanded',
          expanded ? 'true' : 'false'
        );


        if (expanded) {

          content.style.maxHeight =
            content.scrollHeight + 'px';

          if (buttonText) {
            buttonText.textContent =
              'SHOW LESS';
          }

        } else {

          content.style.maxHeight = '';

          if (buttonText) {
            buttonText.textContent =
              'VIEW FULL DETAILS';
          }

        }

      }
    );


    checkLength();

    window.addEventListener(
      'resize',
      checkLength
    );
  }


  function initAllDescriptions() {
    document
      .querySelectorAll('[data-wf-pdesc]')
      .forEach(function (root) {
        initPremiumDescription(root);
      });
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAllDescriptions
    );

  } else {

    initAllDescriptions();

  }


  document.addEventListener(
    'shopify:section:load',
    initAllDescriptions
  );

})();